<template>
    <div class="submit-account" :class="lang">
        <img class="icon" v-if="bgColor != 'black-theme'" src="../../../assets/images/open-account/Group 1738@3x.png" />
        <img class="icon" v-else src="../../../assets/images/open-account/Group 1138@3x .png" />
        <span class="message">{{ $t("orgAccResult.g000001") }}</span>
        <span class="detail">{{ $t('orgAccResult.g000001') }}。{{ $t('orgAccResult.g000002') }} {{ email }}，{{ $t('orgAccResult.g000003') }}。</span>
        <nav-buttons
          :isFixed="false"
          :showPrev="false"
          :nextText="$t('common.confirm')"
          customClass="operation"
          @on-next="handleComplete" 
        />
    </div>
  </template>

  <script>
  import navButtons from '../components/navButtons.vue'
  import { Toast } from "vant";
  import { getBrowser } from "@/utils/browser";
  import { closeWebView } from "@/utils/hybirdMethods";

  export default {
    name: 'SubmitAccount',
    components: {
      navButtons
    },
    data(){
      return {
        acceptance_sn:'',
        lang: 'zh-CN',
        email: ''
      }
    },
    created() {
      this.init()
    },
    computed: {
      bgColor() {
        return this.$store.getters["common/bgColor"];
      },
    },
    methods: {
      init(){
        const institutionalForm = localStorage.getItem('institutionalForm');
        const userInfo = institutionalForm ? JSON.parse(institutionalForm) : {};
        this.email = userInfo?.email || '';
        
        this.getLang();
      },
      getLang() {
        this.lang = localStorage.getItem('localLang') || 'zh-CN';
      },
      handleComplete() {
        // 清空缓存
        localStorage.removeItem('institutionalForm');
        const browser = getBrowser()
        const isAPP = browser.isApp;
        if(isAPP){
          closeWebView();
        }else{
          const toastLoading = Toast.loading({
            duration: 0,
            forbidClick: true,
            loadingType: "spinner",
            message: this.$t("common.loading_text")
          });
          this.$router.push({
            path:'/open-account/home'
          }).finally(() =>{
            toastLoading.clear()
          })
        }
      }
    }
  }
  </script>

  <style lang="less">
  .submit-account {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 94px;
    box-sizing: border-box;
    background: white;
    min-height: 100vh;
    .icon {
      width: 120px;
      height: 120px;
    }
    .message {
      width: 290px;
      font-size: 40px;
      font-weight: 600;
      color: #17161c;
      line-height: 40px;
      margin: 38px 0px;
    }
    .detail {
      text-align: center;
      width: 580px;
      font-size: 28px;
      color: #17161c;
      line-height: 48px;
      margin-bottom: 142px;
    }
    
    &.en {
      .message {
        width: 580px;
        text-align: center;
        line-height: 50px;
      }
      .detail {
        width: 630px;
      }
    }
  }
  .black-theme {
    .submit-account {
      background: #1B1C24 !important;
      .message, .detail {
        color: white;
      }
    }
  }
  </style>
